import React from "react";
import Table from "../../components/subcomponents/table";
import TableControl from "../../components/subcomponents/table_control";
import Button from "../../components/subcomponents/controls/button";
import InputField from "../../components/subcomponents/controls/inputfield";
import SelectField from "../../components/subcomponents/controls/selectfield";
import CheckField from "../../components/subcomponents/controls/checkfield";
import { connect } from "react-redux";
import subscribers from "../../api/subscribers";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import FormHeader from "../../components/subcomponents/formheader";
import keyGenerator from "../../helper/key_generator";
import isPermitted from "../../permissions/permissions";

class subscriberList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allow_to_edit: false,
            edit_rec: false,
            new_rec: false,
        };
    }
    componentDidMount() {
        subscribers.list();
        subscribers.options();
        this.props.handleSelect();
        if (isPermitted("Admin")) {
            this.props.handleFilter({ name: "company_id", value: this.props.user.company_id })
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.subscriber_details.company_id !== prevProps.subscriber_details.company_id) {
            subscribers.options(this.props.subscriber_details.company_id);
        }
    }
    selectItem(id) {
        if (this.state.new_rec || this.state.allow_to_edit) {
            notification.error("New/edit rec mode, please cancel before select");
            return null;
        }
        if (id) {
            this.setState({ edit_rec: true });
            this.setState({ allow_to_edit: false });
            this.props.handleSelect(id);
            subscribers.details();
        } else {
            this.cancel();
        }
    }
    cancel() {
        this.setState({ new_rec: false });
        this.setState({ edit_rec: false });
        this.setState({ allow_to_edit: false });
        this.props.handleSelect();
    }
    newRec() {
        this.props.handleSelect();
        this.props.fieldChange({ name: "company_id", value: this.props.user?.company_id });
        this.setState({ new_rec: true });
    }
    saveRec() {
        let self = this;
        const selected = this.props.subscriber_selected;
        if (this.state.edit_rec) {
            subscribers.update((error) => {
                if (!error) {
                    subscribers.list();
                    self.cancel();
                    this.selectItem(selected);
                }
            });
        } else {
            subscribers.add(function (error) {
                if (!error) {
                    subscribers.list();
                    self.cancel();
                }
            });
        }
    }
    generateKey() {
        const key = keyGenerator(12);
        this.props.fieldChange({ name: "key", value: key })
    }
    deleteRec() {
        let self = this;
        subscribers.del(function (error) {
            if (!error) {
                subscribers.list();
                self.cancel();
            }
        });
    }
    allowEdit(params) {
        this.setState({ allow_to_edit: params.value });
    }
    showDetails() {
        let details_title = this.state.edit_rec
            ? "Subscribers details"
            : "Enter new subscriber";
        let confirm_toggle_status = !this.state.new_rec ? "enabled" : "hidden";

        let save_btn =
            this.props.subscriber_details.company_id &&
                this.props.subscriber_details.cntrl_id &&
                this.props.subscriber_details.key
                ? "enabled"
                : "disabled";
        if (this.state.edit_rec && !this.state.allow_to_edit) save_btn = "hidden";

        let del_btn =
            this.state.edit_rec && this.state.allow_to_edit ? "enabled" : "hidden";

        let inputs_enabled =
            this.state.new_rec ? "enabled" : "disabled";

        let save_btn_label = this.state.edit_rec
            ? "Update"
            : "Add new";

        let company_select_input_enabled = this.state.new_rec && isPermitted("Admin") ? "enabled" : "disabled";
        let generate_input_enabled = this.state.new_rec || this.state.allow_to_edit ? "enabled" : "disabled";


        let show_link_point =
            this.state.allow_to_edit || this.state.new_rec ? "hidden" : "disabled";
        let show_copy_link = this.state.allow_to_edit || this.state.new_rec ? "hidden" : "enabled";
        let linkpoint =
            window.location.protocol +
            "//" +
            window.location.hostname +
            ":4037/race_feed?type=default&token=" +
            this.props.subscriber_details.key;

        return (
            <SubformDetails
                is_hidden={!this.state.new_rec && !this.state.edit_rec}
                title={details_title}
                className="details width_50"
            >
                <CheckField
                    status={confirm_toggle_status}
                    name="allow_to_edit"
                    label="Enable edit"
                    onChange={this.allowEdit.bind(this)}
                    value={this.state.allow_to_edit}
                />
                <SelectField
                    status={company_select_input_enabled}
                    name="company_id"
                    label="Company"
                    options={this.props.subscriber_options["company_id"]}
                    onChange={this.props.fieldChange}
                    value={this.props.subscriber_details.company_id}
                    error={this.props.subscriber_details["company_id"]}
                />
                <SelectField
                    status={inputs_enabled}
                    name="cntrl_id"
                    label="Controller"
                    options={this.props.subscriber_options["cntrl_id"]}
                    onChange={this.props.fieldChange}
                    value={this.props.subscriber_details.cntrl_id}
                    error={this.props.subscriber_details["cntrl_id"]}
                />
                <div className="field_group">
                    <InputField
                        status="disabled"
                        name="key"
                        label="Key"
                        onChange={this.props.fieldChange}
                        value={this.props.subscriber_details.key}
                        type="text"
                        error={this.props.subscriber_validation["key"]}
                    />
                    <Button
                        name="generate"
                        label="Generate key"
                        onClick={this.generateKey.bind(this)}
                        status={generate_input_enabled}
                    />
                </div>
                <div className="toolbar">
                    <Button
                        name="add"
                        label={save_btn_label}
                        onClick={this.saveRec.bind(this)}
                        status={save_btn}
                    />
                    <Button
                        name="delete"
                        label="Delete"
                        onClick={this.deleteRec.bind(this)}
                        status={del_btn}
                    />
                    <Button
                        name="cancel"
                        label="Cancel"
                        onClick={this.cancel.bind(this)}
                    />
                    <Button status={show_copy_link} name="copy_to" label="Copy link to clipboard" onClick={() => { navigator.clipboard.writeText(linkpoint) }} />
                </div>
                <InputField
                    status={show_link_point}
                    name="linkpoint"
                    label="Link"
                    value={linkpoint}
                    type="text"
                />
            </SubformDetails>
        );
    }
    render() {
        let new_btn = this.state.edit_rec ? "hidden" : "enabled";
        const filter = (isPermitted("Admin") && !this.state.edit_rec && !this.state.new_rec)
            ? { options: this.props.subscriber_options["company_id"], value: this.props.subscriber_filter["company_id"] }
            : null
        return (
            <div className="form_wrap subscribers_list">
                <FormHeader title="SUBSCRIBERS LIST" />
                <SubformDetails className="master width_50">
                    <TableControl
                        search={this.props.search_string}
                        filter={filter}
                        handleSearch={this.props.handleSearch}
                        handleFilter={this.props.handleFilter}
                    />
                    <Table
                        name="admin_list"
                        table_key={"subscriber_id"}
                        handleSelect={this.selectItem.bind(this)}
                        selected={this.props.subscriber_selected}
                        headers={{
                            subscriber_id: { label: "ID", width: "5%" },
                            company_name: { label: "Company", width: "30%" },
                            controller_alias: { label: "Controller", width: "25%" },
                            cntrl_id: { label: "Cntrl_id", width: "20%" },
                            key: { label: "Key", width: "20%" },
                        }}
                        data={this.props.subscriber_list}
                    />
                    <Button
                        name="new"
                        label="New subscriber"
                        onClick={this.newRec.bind(this)}
                        status={new_btn}
                    />
                </SubformDetails>
                {this.showDetails()}
            </div>
        );
    }
}

/**
 * [Converts plain obj to arr for state]
 * @param obj
 */
function stateArr(obj = {}) {
    let state_arr = [];
    Object.keys(obj).forEach((field) => {
        state_arr.push(obj[field]);
    });
    return state_arr;
}

function mapStateToProps(state) {
    let subscriber = state.subscriberR.subscriber;
    let user = state.authR.user;
    return {
        search_string: subscriber.search_string,
        subscriber_list: subscriber.list,
        subscriber_selected: subscriber.selected,
        subscriber_filter: subscriber.filter,

        subscriber_details: subscriber.details,
        subscriber_state: stateArr(subscriber.detail),

        subscriber_validation: subscriber.validation,
        subscriber_options: subscriber.options,
        user: user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch(result) {
            dispatch({
                type: "SUBSCRIBER_DESELECTED",
            });
            dispatch({
                type: "SUBSCRIBER_UPDATE_SEARCH_STRING",
                value: result.value,
            });
            subscribers.list();
        },
        handleFilter(result) {
            dispatch({
                type: "SUBSCRIBER_DESELECTED",
            });
            dispatch({
                type: "SUBSCRIBER_UPDATE_FILTER_STRING",
                value: result.value ? { [result.name]: result.value } : {},
            });
            subscribers.list();
        },
        handleSelect(id) {
            if (id) {
                dispatch({
                    type: "SUBSCRIBER_SELECTED",
                    value: id,
                });
            } else {
                dispatch({
                    type: "SUBSCRIBER_DESELECTED",
                });
            }
        },
        cancelSelect() {
            dispatch({
                type: "SUBSCRIBER_CANCEL_SELECT",
            });
        },
        fieldChange(result) {
            dispatch({
                type: "SUBSCRIBER_UPDATE_FORM",
                field: result.name,
                value: result.value,
            });
            if (result.name === "company_id") {
                subscribers.options(result.value)
            }
        },
    };
}

export default subscriberList = connect(
    mapStateToProps,
    mapDispatchToProps
)(subscriberList);
